import { createFileRoute } from "@tanstack/react-router";
import { seoDiscoveryHeaders } from "@/lib/seo-discovery";
import { buildAppLink } from "@garimpa/lib/buildAppLink";
export function buildRobotsTxt(): string {
  const lines = ["User-agent: *", "Allow: /",
  // Crawlers fetch sign-in and store click-out links despite rel="nofollow"/"sponsored";
  // neither is indexable, and click-outs would send crawlers on to the stores.
  "Disallow: /login", "Disallow: /offers/*/redirect", "Content-Signal: ai-train=yes, search=yes, ai-input=yes", "", `Sitemap: ${buildAppLink(["sitemap_index.xml"])}`, ""];
  return lines.join("\n");
}
export function robotsResponse(): Response {
  return new Response(buildRobotsTxt(), {
    headers: seoDiscoveryHeaders("text/plain; charset=utf-8")
  });
}
export const Route = createFileRoute("/robots.txt")({});